module.exports = __webpack_public_path__ + "static/img/qmwallet1-benefit-item-bg.7f218028.png";